import React, { useState } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';

import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Colxx } from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Inventory } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

function InventoryEditModal({ isVisible, toggleModal, propertyId, roomlist }) {
  const [inputFields, setInputFields] = useState([
    { roomTypeId: '', startDate: '', endDate: '', count: 0 },
  ]);

  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({ roomTypeId: '', startDate: '', endDate: '', count: 0 });
    setInputFields(values);
  };

  const handleRemoveFields = index => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    switch (event.target.name) {
      case 'roomTypeId':
        values[index].roomTypeId = event.target.value;
        break;
      case 'startDate':
        values[index].startDate = event.target.value;
        break;
      case 'endDate':
        values[index].endDate = event.target.value;
        break;
      case 'count':
        values[index].count = event.target.value;
        break;

      default:
        break;
    }

    setInputFields(values);
  };

  const handleUpdate = () => {
    AxiosAPI({
      url: postAPI_Update_Inventory,
      method: 'post',
      data: {
        propertyId,
        data: inputFields,
      },
    }).then(
      setTimeout(() => {
        window.location.reload();
      }, 300)
    );
  };

  return (
    <div>
      <Modal size="lg" isOpen={isVisible} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Bulk Edit</ModalHeader>
        <AvForm onSubmit={handleUpdate}>
          <ModalBody>
            <AvGroup row>
              {inputFields.map((inputField, index) => (
                <Row key={`${inputField}~${index}`}>
                  <Colxx sm={3}>
                    <AvGroup>
                      <Label>Room Type</Label>
                      <AvInput
                        required
                        name="roomTypeId"
                        type="select"
                        value={inputField.roomTypeId}
                        onChange={event => handleInputChange(index, event)}
                      >
                        <option value="" disabled hidden>
                          Room Type
                        </option>
                        {roomlist.map((elem, index) => (
                          <option value={elem.roomTypeId} key={index}>
                            {elem.roomName}
                          </option>
                        ))}
                      </AvInput>
                      {/* <AvFeedback>Choose the room type!</AvFeedback> */}
                    </AvGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <AvGroup>
                      <Label>Start Date</Label>
                      <AvInput
                        required
                        type="date"
                        name="startDate"
                        value={inputField.startDate}
                        onChange={event => handleInputChange(index, event)}
                      />
                      {/* <AvFeedback>Choose the start date!</AvFeedback> */}
                    </AvGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <AvGroup>
                      <Label>End Date</Label>
                      <AvInput
                        required
                        type="date"
                        name="endDate"
                        value={inputField.endDate}
                        onChange={event => handleInputChange(index, event)}
                      />
                      {/* <AvFeedback>Choose the end date!</AvFeedback> */}
                    </AvGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <AvGroup>
                      <Label>Inventory</Label>
                      <AvInput
                        required
                        name="count"
                        type="number"
                        min={0}
                        onChange={event => handleInputChange(index, event)}
                        value={inputField.count}
                      />
                      {/* <AvFeedback>Set the inventory number!</AvFeedback> */}
                    </AvGroup>
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <div>
                      <Button
                        style={{ margin: '6px' }}
                        onClick={handleAddFields}
                        color="primary"
                        size="xs"
                        outline
                      >
                        + Add More
                      </Button>
                      {inputFields.length > 1 && (
                        <Button
                          style={{ margin: '6px' }}
                          onClick={() => handleRemoveFields(index)}
                          color="secondary"
                          size="xs"
                          outline
                        >
                          -
                        </Button>
                      )}
                    </div>
                  </Colxx>
                </Row>
              ))}
            </AvGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              Update
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </AvForm>
      </Modal>
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(InventoryEditModal));
